import { createContext, useContext } from 'react'

import { createBrowserRouter } from 'react-router'

const initialState: { router: ReturnType<typeof createBrowserRouter> | null } = {
  router: null,
}

export const RouterContext = createContext(initialState)
export const useRouterContext = () => useContext(RouterContext)
